/* Native content remains readable without these optional navigation helpers. */
(() => {
  'use strict';
  if (document.querySelector('.cv-questions')) {
    const supportStateKey = 'tmSupportQuestions';
    const supportPanels = () => [...document.querySelectorAll('[data-support-question]')];
    const restoreSupport = () => {
      const saved = history.state?.[supportStateKey];
      if (!Array.isArray(saved)) return;
      supportPanels().forEach(panel => { panel.open = saved.includes(panel.dataset.supportQuestion); });
    };
    const rememberSupport = () => {
      const previous = history.state && typeof history.state === 'object' && !Array.isArray(history.state) ? history.state : {};
      const open = supportPanels().filter(panel => panel.open).map(panel => panel.dataset.supportQuestion);
      if (JSON.stringify(previous[supportStateKey]) === JSON.stringify(open)) return;
      try {
        history.replaceState({...previous, [supportStateKey]: open}, '');
      } catch {
        // Native disclosures remain usable when history state is unavailable.
      }
    };
    restoreSupport();
    document.addEventListener('toggle', event => {
      if (event.target.matches?.('[data-support-question]')) rememberSupport();
    }, true);
    addEventListener('pagehide', rememberSupport);
    addEventListener('pageshow', restoreSupport);
    document.addEventListener('shopify:section:load', restoreSupport);
  }
  const feedback = document.querySelector('[data-contact-feedback]');
  if (feedback) feedback.focus();
  const topic = document.querySelector('#ContactSubject');
  if (topic && !topic.form.querySelector('.form-errors')) {
    const query = new URLSearchParams(location.search);
    const legacy = query.get('subject');
    const requested = query.get('topic') || (legacy === 'MateTurbo availability' ? 'product' : legacy === 'Privacy request' ? 'privacy' : '');
    const option = [...topic.options].find(item => item.dataset.topic === requested);
    if (option) topic.value = option.value;
  }
  const article = document.querySelector('[data-policy-body]');
  const index = document.querySelector('[data-policy-index]');
  if (!article || !index) return;
  const headings = [...article.querySelectorAll('h2')];
  if (headings.length < 2) return;
  const nav = index.querySelector('nav');
  headings.forEach((heading, position) => {
    if (!heading.id) heading.id = `policy-section-${position + 1}`;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    // Native fragment navigation scrolls and focuses the heading on Safari.
    heading.setAttribute('tabindex', '-1');
    nav.append(link);
  });
  index.hidden = false;
  index.open = matchMedia('(min-width: 801px)').matches;
})();
